import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LogoutButton from './LogoutButton';
import { useEffect } from 'react';
import { useCounts } from '../context/CountsContext';

export default function Navbar() {
  //const { user } = useAuth();
  /* const [counts, setCounts] = useState({ passengerCount: 0, approverCount: 0, adminCount: 0 }); */
  const { counts, refreshCounts } = useCounts();
  let user = null;
  try {
    const auth = useAuth();
    user = auth.user;
  } catch (err) {
    console.warn('Auth context not ready yet:', err.message);
  }

  useEffect(() => { refreshCounts(); }, [refreshCounts]);

  return (
    <nav className="navbar navbar-expand-lg bg-primary" data-bs-theme="dark">
      <Link className="navbar-brand" to="/">
        Car Bookings
      </Link>

      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav me-auto">
          {user && (
            <>
              <li className="nav-item">
                <Link className="nav-link" to="/bookings">
                  Car Bookings
                </Link>
              </li>              
              {user?.isCarBookingAdmin && (
                <li className="nav-item">
                  <Link className="nav-link" to="/vehicles">
                    Vehicle List
                  </Link>
                </li>
              )}              
            </>
          )}
        </ul>

        {/* <ul className="navbar-nav ms-auto">
          {counts.passengerCount > 0 && (
            <li className="nav-item me-3">
              <span className="badge bg-warning text-dark">
                Passenger: {counts.passengerCount}
              </span>
            </li>
          )}

          {counts.approverCount > 0 && (
            <li className="nav-item me-3">
              <span className="badge bg-primary">
                Approvals: {counts.approverCount}
              </span>
            </li>
          )}

          {counts.adminCount > 0 && (
            <li className="nav-item">
              <span className="badge bg-success">
                Admin Grants: {counts.adminCount}
              </span>
            </li>
          )}
        </ul> */}
        <ul className="navbar-nav ms-auto">
          {counts.passengerCount > 0 && (
            <li className="nav-item me-3">
              <Link to="/bookings?type=passenger" className="badge bg-warning text-dark text-decoration-none">
                Passenger: {counts.passengerCount}
              </Link>
            </li>
          )}

          {counts.approverCount > 0 && (
            <li className="nav-item me-3">
              <Link to="/bookings?type=approver" className="badge bg-info text-decoration-none">
                Approvals: {counts.approverCount}
              </Link>
            </li>
          )}

          {counts.adminCount > 0 && (
            <li className="nav-item">
              <Link to="/bookings?type=admin" className="badge bg-success text-decoration-none">
                Admin Grants: {counts.adminCount}
              </Link>
            </li>
          )}
        </ul>


        <ul className="navbar-nav ms-auto">
          {user ? (
            <>
              <li className="nav-item">
                <span className="nav-link text-light">
                  👤 {user.name} ({user.role})
                </span>
              </li>
              <li className="nav-item mt-1">
                <LogoutButton />
              </li>
            </>
          ) : (
            <>
              <li className="nav-item">
                <Link className="nav-link" to="/login">
                  👤 Login
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
}
